/**
 * SSE 封装：订阅 /api/v1/jobs/{id}/events
 * 事件：connected / job_update / task_update / material_added
 * EventSource 断线自动重连；调用方负责 close()
 */
export function subscribeJobEvents(jobId, handlers = {}) {
  const es = new EventSource(`/api/v1/jobs/${jobId}/events`)

  const on = (name, fn) => {
    es.addEventListener(name, e => {
      try {
        fn(JSON.parse(e.data))
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error(`SSE 事件 ${name} 解析失败:`, e.data, err)
      }
    })
  }

  if (handlers.onConnected) on('connected', handlers.onConnected)
  if (handlers.onJobUpdate) on('job_update', handlers.onJobUpdate)
  if (handlers.onTaskUpdate) on('task_update', handlers.onTaskUpdate)
  if (handlers.onMaterialAdded) on('material_added', handlers.onMaterialAdded)
  // 视频生成的中途提示（如"背景音乐涉及版权，正在重新处理"）—— 由后端 VideoAgent 推进来
  if (handlers.onVideoNote) on('video_note', handlers.onVideoNote)

  es.onerror = () => {
    // EventSource 会自动重连；服务端主动 close 后由调用方关闭
  }

  return es
}
